var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_62",
    "data-name": "Group 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.372,
    height: 54.372,
    viewBox: "0 0 54.372 54.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 54.372,
    height: 54.372,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M54.372,27.186A27.186,27.186,0,1,1,27.186,0,27.186,27.186,0,0,1,54.372,27.186",
    transform: "translate(0 0)",
    fill: "#e84142",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M23.6,41.6H18.32a4.242,4.242,0,0,1-1.991-.213,1.345,1.345,0,0,1-.608-1.049c-.02-.394.254-.875.8-1.836L29.551,15.543c.554-.975.835-1.463,1.189-1.643a1.34,1.34,0,0,1,1.215,0c.354.18.635.667,1.189,1.643l2.679,4.675.013.024a8.785,8.785,0,0,1,1.035,2.133,3.966,3.966,0,0,1,0,1.857,8.816,8.816,0,0,1-1.042,2.157l-6.843,12.1-.018.031a8.679,8.679,0,0,1-1.331,1.992,3.974,3.974,0,0,1-1.624.942A9.536,9.536,0,0,1,23.6,41.6",
    transform: "translate(-4.114 -3.599)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M43.507,47.453h7.56a4.2,4.2,0,0,0,2.01-.22,1.337,1.337,0,0,0,.608-1.055c.019-.382-.249-.844-.774-1.749l-.055-.095L49.07,37.857l-.044-.073c-.532-.9-.8-1.354-1.145-1.53a1.331,1.331,0,0,0-1.209,0c-.348.18-.628.654-1.182,1.61l-3.774,6.478-.013.022c-.552.954-.828,1.43-.808,1.821A1.353,1.353,0,0,0,41.5,47.24a4.277,4.277,0,0,0,2,.213",
    transform: "translate(-10.701 -9.448)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.1bb6168a7b286e2bbfe4f3758189a7d7.svg";
export { ForwardRef as ReactComponent };